import React, { FC, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  NotificationButtons,
  NotificationMessages,
  useTrackNotificationInteraction,
} from '../../utils/hooks/bi/useTrackNotificationInteraction';
import { Notification } from '../common/Notification';
import { NotificationTheme } from '../common/Notification/Notification.types';
import { TextButton } from '../common/wixCommon';
import {
  INotificationComponentOuter,
  INotificationWithTryAgainLink,
} from './notifications.types';

export const deleteFailedNotification = ({
  onTryAgain,
  fileId,
}: INotificationWithTryAgainLink) => {
  const DeleteFailedNotificationComponent: FC<INotificationComponentOuter> = ({
    onClose,
  }) => {
    const {
      trackErrorClick,
      trackErrorShown,
    } = useTrackNotificationInteraction();

    const handleTryAgainClick = useCallback(() => {
      trackErrorClick({
        errorMessage: NotificationMessages.DeleteFailed,
        fileId,
        buttonName: NotificationButtons.TryAgain,
      });
      onTryAgain();
    }, [trackErrorClick, fileId, onTryAgain]);

    const handleCloseClick = useCallback(() => {
      trackErrorClick({
        errorMessage: NotificationMessages.DeleteFailed,
        fileId,
        buttonName: NotificationButtons.Close,
      });
    }, [trackErrorClick, fileId]);

    useEffect(() => {
      trackErrorShown({
        errorMessage: NotificationMessages.DeleteFailed,
        fileId,
      });
    }, [trackErrorShown, fileId]);

    const tryAgainLink = (
      <TextButton
        as="button"
        onClick={handleTryAgainClick}
        skin="light"
        underline="always"
        dataHook="delete-failed-notification-label-button"
      >
        <FormattedMessage id="video-maker-home.notification.link.try-again" />
      </TextButton>
    );

    return (
      <Notification
        dataHook="delete-failed-notification"
        theme={NotificationTheme.Warning}
        label={
          <FormattedMessage
            id="video-maker-home.notification.error.delete"
            values={{
              tryAgainMessage: (
                <FormattedMessage
                  id="video-maker-home.notification.try-again"
                  values={{ tryAgainLink }}
                />
              ),
            }}
          />
        }
        onCloseButtonClick={handleCloseClick}
        onClose={onClose}
      />
    );
  };

  return DeleteFailedNotificationComponent;
};
